import { Component } from '@angular/core';

@Component({
  selector: 'neoris-auto-sanity-check',
  templateUrl: './auto-sanity-check.component.html',
  styleUrl: './auto-sanity-check.component.css'
})
export class AutoSanityCheckComponent {

}
